import React from 'react';
import { TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

import Image from '@src/components/Image';

const Content = styled(Image)`
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 3px;
  width: 24px;
  height: 24px;
  resize-mode: contain;
`;
const Row = styled.View`
  flex-direction: row;
  margin-right: 16px;
  align-items: center;
  justify-content: space-between;
`;
type Props = {
  OnSharePress: () => void;
};
const Component: React.FC<Props> = ({ OnSharePress }) => {
  return (
    <Row>
      {/* <Content source={require('@src/assets/images/feather_bookmark.png')} /> */}
      <TouchableOpacity onPress={OnSharePress}>
        <Content source={require('@src/assets/images/share.png')} />
      </TouchableOpacity>
      {/* <Content source={require('@src/assets/images/heart.png')} /> */}
    </Row>
  );
};

Component.displayName = 'TourHeaderRight';

export default React.memo(Component);
